import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, signal } from '@angular/core';
import { Chart, ChartData } from 'chart.js';
import { cloneDeep } from 'lodash';
import { SelectChangeEvent } from 'primeng/select';

import { IChartConfigForModule, ISelectedChartOptions } from '~/repositories/search/store/search.types';
import { chartIntervalOptions } from '~/search/search/search.const';

@Component({
  selector: 'app-results-graph',
  templateUrl: './results-graph.component.html',
  styleUrls: ['./results-graph.component.scss'],
  standalone: false
})
export class ResultsGraphComponent implements AfterViewInit {
  @ViewChild('chartRef') chartRef: ElementRef;

  @Input() chartOptions: IChartConfigForModule;
  @Input() currentChartOptions: ISelectedChartOptions;
  @Input() showOptions: boolean = true;
  @Input() results: ChartData;
  @Output() currentChartOptionsChange: EventEmitter<ISelectedChartOptions> = new EventEmitter();

  public chart = signal(null);

  intervalOptions = chartIntervalOptions;

  ngAfterViewInit() {
    if (this.chart()) this.chart().destroy();

    this.chart.set(
      new Chart(this.chartRef?.nativeElement, {
        type: 'bar', //this denotes tha type of chart
        data: cloneDeep(this.results),
        options: {
          responsive: true
        }
      })
    );
  }

  /* selectedChartOption = CHARTTYPES.BAR;
  documentStyle = getComputedStyle(document.documentElement);
  textColor = this.documentStyle.getPropertyValue('--text-color');
  textColorSecondary = this.documentStyle.getPropertyValue('--text-color-secondary');
  surfaceBorder = this.documentStyle.getPropertyValue('--surface-border');

  basicOptions = {
    plugins: {
      legend: {
        labels: {
          color: this.textColor
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: this.textColorSecondary
        },
        grid: {
          color: this.surfaceBorder,
          drawBorder: false
        }
      },
      x: {
        ticks: {
          color: this.textColorSecondary
        },
        grid: {
          color: this.surfaceBorder,
          drawBorder: false
        }
      }
    }
  }; */

  changeChartOptions(key: string, event: SelectChangeEvent) {
    this.currentChartOptionsChange.emit({
      ...this.currentChartOptions,
      [key]: event.value
    });
  }

  changeChartInterval(key: string, event: SelectChangeEvent) {
    this.currentChartOptionsChange.emit({
      ...this.currentChartOptions,
      [key]: this.intervalOptions.find((item) => item.value === event.value)
    });
  }
}
